import React from 'react';
import './Nav.css'
const Nav = (props) => {
    const classes = [];
    if(props.scroll){
        classes.push('shadow');
    }
    
    return (
        <nav className={classes.join(" ")}>
            <h2>
                VoteChain
        </h2>
            <ul>
                <li>
                    <a href="#">Home</a>
                </li>
            </ul>
        </nav>

    );
};
export default Nav;


// WEBPACK FOOTER //
// ./src/components/Navbar/Nav.js